import React from 'react'
import "./Preloader.css"
export default function Preloader() {
  return (
    <div className="preloader">
    <img src="/assets/images/logo.png" alt="Logo" className="preloader__logo" />
  </div>
  )
}
